<script lang="ts">
  import { Col, Form, FormGroup, Input, InputGroup, Label, Row } from "sveltestrap";
  import { YourEducation } from "../../../../utils/Constant/Constant";
</script>
<h6 class="mb-0">{YourEducation}</h6>
<Form class="theme-form">
  <Row>
    <Col xl="6" class="xl-100">
      <FormGroup>
        <Label for="exampleFormControlInput5">{'College Name:'}
          <span class="font-danger">*</span>
        </Label>
        <Input id="exampleFormControlInput5" type="email" placeholder="Enter college name" />
      </FormGroup>
    </Col>
    <Col xl="6" class="xl-100 xl-mt-job">
      <Label class="col-form-label text-end pt-0">{'Period:'}
        <span class="font-danger">*</span>
      </Label>
      <Row>
        <Col sm="6">
          <InputGroup>
            <Input class="datepicker-here digits" type="text" placeholder="Start Date"/>
          </InputGroup>
        </Col>
        <Col sm="6" class="xs-mt-period">
          <InputGroup>
            <Input class="datepicker-here digits" type="text" placeholder="End Date" />
          </InputGroup>
        </Col>
      </Row>
    </Col>
    <Col xl="6" class="xl-100">
      <FormGroup>
        <Label >{'Degree Level:'}
          <span class="font-danger">*</span>
        </Label>
        <Input type="select" value="Choose a Option" class="js-example-basic-single col-sm-12 job-select2">
            <option >{'Student'}</option>
            <option >{'Bachelor'}</option>
            <option >{'Master'}</option>
            <option >{'Associate'}</option>
        </Input>
      </FormGroup>
    </Col>
    <Col xl="6" class="xl-100">
      <FormGroup>
        <Label for="exampleFormControlInput6">{'Specialization:'}
          <span class="font-danger">*</span>
        </Label>
        <Input id="exampleFormControlInput6" type="email" placeholder="Enter specialization" />
      </FormGroup>
    </Col>
  </Row>
</Form>